import React from "react";
import FormBuilderScreen from "./form-builder";

export default function Form() {
  return <FormBuilderScreen />;
}
